import React from 'react';
import { Clock, Plus, CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

const getPriorityColor = (priority) => {
  const colors = {
    'low': 'bg-gray-100 text-gray-800',
    'medium': 'bg-blue-100 text-blue-800',
    'high': 'bg-orange-100 text-orange-800',
    'urgent': 'bg-red-100 text-red-800'
  };
  return colors[priority] || 'bg-gray-100 text-gray-800';
};

export { getPriorityColor };

export const FollowUpList = ({ followUps, onComplete, onCreateNew }) => {
  if (followUps.length === 0) {
    return (
      <Card>
        <CardContent className="py-12 text-center">
          <Clock className="h-12 w-12 text-gray-300 mx-auto mb-4" />
          <p className="text-gray-500">No pending follow-ups</p>
          <Button onClick={onCreateNew} className="mt-4">
            <Plus className="h-4 w-4 mr-2" />
            Create Follow-Up
          </Button>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-3">
      {followUps.map((followUp) => (
        <Card key={followUp.follow_up_id} data-testid={`followup-${followUp.follow_up_id}`}>
          <CardContent className="py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className={`p-2 rounded-full ${
                  followUp.priority === 'urgent' ? 'bg-red-100' :
                  followUp.priority === 'high' ? 'bg-orange-100' : 'bg-blue-100'
                }`}>
                  <Clock className={`h-5 w-5 ${
                    followUp.priority === 'urgent' ? 'text-red-600' :
                    followUp.priority === 'high' ? 'text-orange-600' : 'text-blue-600'
                  }`} />
                </div>
                <div>
                  <p className="font-semibold">{followUp.title}</p>
                  <p className="text-sm text-gray-500">
                    Due: {new Date(followUp.due_date).toLocaleDateString()}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Badge className={getPriorityColor(followUp.priority)}>{followUp.priority}</Badge>
                <Button variant="ghost" size="sm" onClick={() => onComplete(followUp)}>
                  <CheckCircle className="h-4 w-4 mr-1" />
                  Complete
                </Button>
              </div>
            </div>
            {followUp.description && (
              <p className="text-sm text-gray-600 mt-2 ml-14">{followUp.description}</p>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
